import { GetOneAmbulatoryOrder } from 'domain/usecases/ambulatory/get-one-ambulatory-order'
import { NewAmbulatoryRepository } from 'repository/interfaces/new-ambulatory-repository'

export class RemoteGetOneAmbulatoryOrder implements GetOneAmbulatoryOrder {
  private readonly ambulatoryRepository: NewAmbulatoryRepository

  constructor(ambulatoryRepository: NewAmbulatoryRepository) {
    this.ambulatoryRepository = ambulatoryRepository
  }

  get(
    params: GetOneAmbulatoryOrder.Params
  ): Promise<GetOneAmbulatoryOrder.Model> {
    return this.ambulatoryRepository.getOneAmbulatoryOrder(params)
  }
}
